import React from 'react'
import { connect } from 'react-redux'
import Smiley from './Smiley'
import {
    ajaxFeedback,
    clearMaskedCallProxy,
    getAttachmentsUrlsFBList,
    getChatStatus,
    getRequestedVia,
    getStarsJSX,
    setSelectedFeedback,
    warnNoChat
} from './redux/FeedbackRedux'
import ReactDOMServer from 'react-dom/server'
import Linkify from 'linkify-react'

class Feedback extends React.Component {
	constructor(props) {
		super(props);
		// This binding is necessary to make `this` work in the callback
		this.handleClick = this.handleClick.bind(this);
		this.handleDetailClick = this.handleDetailClick.bind(this);
		this.handleChatClick = this.handleChatClick.bind(this);
	  }

	handleChatClick(event) {

        event.preventDefault();

		if(this.props.feedback.is_include_contact && this.props.feedback.is_text)
		{
            if(jQuery('body').width() <= 1000) {
                if(jQuery('body').find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
                    jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
                    jQuery('body').find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
                } else if(jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
                    jQuery('body').find('.feedback-detail-scroll').addClass('is-hidden-mobile');
                    jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
                }
            }
			window.scrollTo(0,jQuery('#chatsection').offset().top - 150);
			document.getElementById('chat-textarea').focus();
			document.getElementById('chat-textarea').select();
		}
		else
		{
			warnNoChat(this.props.feedback.is_include_contact,this.props.dispatch);
		}


	}

	handleNotesClick(event) {
		event.preventDefault();
		window.scrollTo(0,jQuery('.feedback-detail h5#notes').offset().top - 150);
		document.getElementById('noteInput').focus();
        document.getElementById('noteInput').select();

        if(jQuery('body').width() <= 1000) {
			if(jQuery('body').find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
				jQuery('body').find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
			} else if(jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-detail-scroll').addClass('is-hidden-mobile');
				jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
			}
		}
	}

	handleAttachmentClick(event) {
		event.stopPropagation();

		if (this.props.feedback.id != this.props.state.selected_feedback)
		{
			var payload = this.props.feedback;
			this.props.dispatch(setSelectedFeedback(payload.id));
			this.props.dispatch(ajaxFeedback(payload.id,function(){
				window.scrollTo(0, jQuery('#feedback_detail_attachments').offset().top - 150);
			}));
		}
		else
		{
			event.preventDefault();
			window.scrollTo(0, jQuery('#feedback_detail_attachments').offset().top - 150);

        }

		if(jQuery('body').width() <= 1000) {
			if(jQuery('body').find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
				jQuery('body').find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
			} else if(jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
				jQuery('body').find('.feedback-detail-scroll').addClass('is-hidden-mobile');
				jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
			}
		}

	}

	handleClick(event) {
        if(!jQuery(event.target).parent().hasClass('go-to')){
            this.props.dispatch(clearMaskedCallProxy());
            event.preventDefault();
            var payload = this.props.feedback;
            this.props.dispatch(setSelectedFeedback(payload.id));
            this.props.dispatch(ajaxFeedback(payload.id));
        }
	  }

	handleDetailClick(event) {
		event.preventDefault();
		var payload = this.props.feedback;
        this.props.dispatch(clearMaskedCallProxy());
		this.props.dispatch(setSelectedFeedback(payload.id));
		this.props.dispatch(ajaxFeedback(payload.id));
		if(jQuery('body').width() <= 1000) {
			setTimeout(function() {
				if(jQuery('body').find('.feedback-detail-scroll').hasClass('is-hidden-mobile')) {
					jQuery('body').find('.feedback-list').addClass('is-hidden-mobile');
					jQuery('body').find('.feedback-detail-scroll').removeClass('is-hidden-mobile');
					jQuery('body').find('.dashboard-stats').addClass('is-hidden-mobile');
				} else if(jQuery('body').find('.feedback-list').hasClass('is-hidden-mobile')) {
					jQuery('body').find('.feedback-detail-scroll').addClass('is-hidden-mobile');
					jQuery('body').find('.feedback-list').removeClass('is-hidden-mobile');
					jQuery('body').find('.dashboard-stats').removeClass('is-hidden-mobile');
				}
			},10);
		}
	}

	render () {
		//requested via list
		const response_via_text = getRequestedVia(this.props.feedback);
		//determine chat status prompt is either 'Chat Started' or 'Chat Not Started'
		const {chat_alert, chat_button_text} = getChatStatus(this.props.feedback);
		const stars = getStarsJSX(this.props.feedback.ratethisbiz_rating, "OTF");

		var attachments = getAttachmentsUrlsFBList(this.props.feedback, this.handleAttachmentClick.bind(this));

        if(this.props.red_alerts_list){
            var keywords = this.props.red_alerts_list;
            if(keywords){
                var chat_red_text = ReactDOMServer.renderToStaticMarkup(<Linkify>{this.props.feedback.description}</Linkify>);
                var i;
                for(i = 0; i < keywords.length; i++){
                    var keyword = keywords[i];
                    if(this.props.feedback.description.toLowerCase().includes(keyword.toLowerCase())){
                        chat_red_text = chat_red_text.replace( new RegExp(keyword, "ig") ,'<span class="text-danger font-weight-bold">'+keyword+'</span>');
                    }
                }
            }
        }

		return (
					<div className="col-sm-12 pr-0" onClick={this.handleClick}>
						<div id={this.props.feedback.id} className={"card feedback " + (this.props.feedback.id == this.props.state.selected_feedback ? "selected" : "") + (chat_alert?" chat-alert":"")}>
							<div className="title-row">
									<div className="card-title">{ this.props.state.current_user ? (this.props.feedback.name?this.props.feedback.name:'Anonymous') : __("Hidden") } <Smiley is_feedback_detail={false} smiley_score={this.props.feedback.smiley_score} /></div>
									<div className="card-title card-title-end ml-lg-auto pl-lg-0 justify-content-lg-end">
										<span className="text-muted">{(this.props.feedback.dow!= "" ? (this.props.feedback.dow+" "+this.props.feedback.created_at).trim().replace(/\d+\/\d+\/\d+\s/,"") : this.props.feedback.created_at)}</span><span className="card-dot text-primary"></span><span className="text-primary">{window.feedbackStatus[this.props.feedback.status].label}</span>
									</div>
							</div>

							<div className="card-body feedback-text border-top text-primary">
								{this.props.feedback.is_internal ? <b>{__("Internal Feedback Submission")}: </b> : null}
                                {this.props.red_alerts_list &&
                                    <b className="feedback-text-span"  dangerouslySetInnerHTML={{__html: chat_red_text}}></b>
                                }
                                {!this.props.red_alerts_list &&
                                    <b className="feedback-text-span" >{this.props.feedback.description}</b>
                                }
							</div>
							<div className="card-body pt-1 pb-2 feedback-actions">
								<div className="row align-items-center">
									<div className="col-lg-12">
										<h6 className="text-muted d-inline-block">Location: {this.props.feedback.tellmyco_name?this.props.feedback.tellmyco_name:this.props.feedback.business_name}</h6>
									</div>
									<div className="col-lg-8">
									<h6 className="text-muted">{response_via_text}<br/>{(chat_alert?<span className="chat-alert-message anim-pulse"><i className="fas fa-exclamation-triangle text-warning mr-1"></i>{this.props.feedback.chat_status}</span>:"")}</h6>
									{this.props.feedback.response_time && <h6 className="text-muted">{ __("Response time") + ':' + this.props.feedback.response_time }</h6>}
									</div>
										{	this.props.feedback.is_text == 1 &&
											<div className="col-lg-4 text-lg-right">
													<a href="#" onClick={this.handleChatClick.bind(this)} className="text-muted go-to">
														<h6 className="text-muted"><i className="far fa-comments"></i> {chat_button_text}</h6>
													</a>
											</div>
										}

									<div className="col-lg-8">
										<h6 className="text-muted">{ __('This Feedback has') } {this.props.feedback.notes} {this.props.feedback.notes == 1?__("note"):__("notes")}</h6>
									</div>
									<div className="col-lg-4 text-lg-right">
									<a href="#" onClick={this.handleNotesClick.bind(this)} className="text-muted go-to">
										<h6 className="text-muted"><i className="far fa-sticky-note"></i> { __('Go to notes') }</h6>
									</a>
									</div>

									<div className="col-lg-7 pr-0">
										<h6 className="text-muted">{ __('This Feedback has') } {this.props.feedback.attachment_count?this.props.feedback.attachment_count:0} {this.props.feedback.attachment_count == 1 ? __("attachment") : __("attachments")}</h6>
									</div>
									<div className="col-lg-5 text-lg-right">
										{(this.props.feedback.attachment_count > 0) &&
											<a href="#" onClick={this.handleAttachmentClick.bind(this)} className="text-muted">
												<h6 className="text-muted"><i className="far fa-paperclip"></i> { __('Go to attachment') }{this.props.feedback.attachment_count == 1 ? "" : "s"}</h6>
											</a>
										}
									</div>
									<div className="col-12">
										<div className="row justify-content-end pr-1 pl-1">
											{attachments}
										</div>
									</div>
									{(this.props.feedback.geolocation &&
									<div className="col-lg-7 pr-0">
										<h6 className="text-muted">{ __('This Feedback has geolocation') }</h6>
									</div>
									)}
								</div>
							</div>

							<div className="card-body pt-3 pb-3 feedback-button border-top">
								<div className="row align-items-center">
									{(this.props.feedback.ratethisbiz_rating !== 0 &&
										<div className="col text-left d-flex pr-0">
											{stars}
										</div>
									)}
									<div className="col text-right">
										<a href="#" onClick={this.handleDetailClick} className="btn btn-sm btn-primary"><i className="far fa-list-alt mr-1"></i> { __('Get Details') }</a>
									</div>
								</div>
							</div>
						</div>
					</div>

		);
	}
}

function mapStateToProps(state) {
	return { state:state }
  }

export default connect(mapStateToProps)(Feedback)
